import styled, { css } from "styled-components";

export const StyledContentWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: ${theme.typography.base.main};
    `
);
